export var MYPROFILES_TABS;
(function (MYPROFILES_TABS) {
    MYPROFILES_TABS["PROFILE"] = "profile";
    MYPROFILES_TABS["API_KEYS"] = "api-keys";
    MYPROFILES_TABS["ORGANIZATIONS"] = "organizations";
})(MYPROFILES_TABS || (MYPROFILES_TABS = {}));
